<script setup lang="ts">
import TimelineScorecardTotalTime from '../components/scorecards/TimelineScorecardTotalTime.vue'
import TimelineScorecardExpenses from '../components/scorecards/TimelineScorecardExpenses.vue'

withDefaults(
  defineProps<{
    date?: Date
  }>(),
  {
    date: () => new Date(),
  }
)
</script>
<template>
  <TimelineScorecardTotalTime />
  <TimelineScorecardExpenses :date="date" />
</template>
